export const getHourFromDate = (date) => {
    if (!date) return null;
    return new Date(date).getHours();
  };

  export const getAvailableHours = () => {
    const hours = Array.from({ length: 24 }, (_, i) =>
      String(i + 1).toString().padStart(2, "0") + ":00"
    );

    return hours.map((hour) => ({
      value: parseInt(hour.split(":")[0]),
      label: hour,
    }));
  };

 